import { Inspection, ModelID, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'inspection_id';
export interface InspectionSearchParams extends SearchParams<Filter, Sort>, Partial<Inspection> {
  franchise_id?: ModelID;
}

export const featurePath = '/v4/equipment/inspection';

export const featureKeys = {
  all: [{ scope: 'inspection' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: InspectionSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
